/** Base path for api-transform-engine connector APIs (apiClient already prefixes /api). */
export const CONNECTOR_CONFIG_BASE = '/connector';

export const CONNECTOR_STATUSES = ['ACTIVE', 'DISABLED'];

export const VERSION_STATUSES = ['DRAFT', 'TESTING', 'ACTIVE', 'ARCHIVED'];

export const DEFAULT_MARMIN_API_VERSION = '20260507';
